(() => {
  const config = JSON.parse(document.getElementById('sonia-pack-config').textContent);
  const variants = new Map(config.variants.map(v => [String(v.id), {...v, size: parseInt(v.option2, 10)}]));
  const money = cents => new Intl.NumberFormat(config.locale, {style:'currency', currency:config.currency}).format(cents / 100);
  function plan(color, count) {
    if (!Number.isInteger(count) || count < 0 || count > 1000) throw new Error(config.error);
    const options = [...variants.values()].filter(v => v.option1 === color && v.available && [1,2,4].includes(v.size));
    const dp = Array(count + 1).fill(null);
    dp[0] = {price:0, items:[]};
    for (let n = 1; n <= count; n++) {
      for (const v of options) {
        const prev = dp[n - v.size];
        if (prev && (!dp[n] || prev.price + v.price < dp[n].price)) dp[n] = {price:prev.price + v.price, items:[...prev.items, v.id]};
      }
    }
    if (!dp[count]) throw new Error(config.error);
    const quantities = new Map();
    dp[count].items.forEach(id => quantities.set(id, (quantities.get(id) || 0) + 1));
    return {price:dp[count].price, items:[...quantities].map(([id, quantity]) => ({id, quantity}))};
  }
  function calculate(cart, change, addition) {
    const groups = new Map();
    const updates = {};
    for (const [index, line] of cart.items.entries()) {
      const v = variants.get(String(line.variant_id));
      if (!v || line.selling_plan_allocation || Object.keys(line.properties || {}).length || line.discount_allocations?.length) continue;
      const quantity = change && index + 1 === change.line ? change.quantity : line.quantity;
      const group = groups.get(v.option1) || {count:0, price:0, lines:[]};
      group.count += v.size * quantity;
      group.price += v.price * quantity;
      group.lines.push({...line, quantity});
      groups.set(v.option1, group);
    }
    if (addition) {
      const v = variants.get(String(addition.id));
      const group = groups.get(v.option1) || {count:0, price:0, lines:[]};
      group.count += v.size * addition.quantity;
      group.price += v.price * addition.quantity;
      groups.set(v.option1, group);
    }
    if (change) {
      const target = cart.items[change.line - 1];
      if (!target) throw new Error(config.error);
      updates[target.key] = change.quantity;
    }
    const protectedColors = new Set(cart.items.filter(l => l.selling_plan_allocation || Object.keys(l.properties || {}).length || l.discount_allocations?.length).map(l => variants.get(String(l.variant_id))?.option1));
    for (const [color, group] of groups) {
      if (protectedColors.has(color)) continue;
      const packed = plan(color, group.count);
      const current = new Map();
      group.lines.forEach(line => current.set(String(line.variant_id), (current.get(String(line.variant_id)) || 0) + line.quantity));
      const target = new Map(packed.items.map(item => [String(item.id),item.quantity]));
      const differs = current.size !== target.size || [...target].some(([id, q]) => current.get(id) !== q);
      const affected = addition && variants.get(String(addition.id)).option1 === color || change && group.lines.some(l => l.key === cart.items[change.line-1]?.key);
      if (differs && (packed.price < group.price || affected)) {
        group.lines.forEach(line => updates[line.key] = 0);
        packed.items.forEach(item => updates[String(item.id)] = item.quantity);
      } else if (change) {
        group.lines.forEach(line => {if (line.quantity !== cart.items.find(l => l.key === line.key).quantity) updates[line.key] = line.quantity;});
      }
    }
    return updates;
  }
  let queue = Promise.resolve();
  const enqueue = action => {
    const task = queue.catch(() => {}).then(action);
    queue = task;
    return task;
  };
  async function request(path, body) {
    const response = await fetch(config.root + path, {method:body ? 'POST' : 'GET', headers:{'Content-Type':'application/json','Accept':'application/json'}, ...(body ? {body:JSON.stringify(body)} : {})});
    const data = await response.json();
    if (!response.ok || data.errors || data.status) throw new Error(typeof data.description === 'string' ? data.description : config.error);
    return data;
  }
  const run = (change, addition) => enqueue(async () => {
    const cart = await request('cart.js');
    if (addition && cart.items.some(l => variants.get(String(l.variant_id))?.option1 === variants.get(String(addition.id)).option1 && (l.selling_plan_allocation || Object.keys(l.properties || {}).length || l.discount_allocations?.length))) throw new Error(config.error);
    const updates = calculate(cart, change, addition);
    if (!Object.keys(updates).length) return false;
    const result = await request('cart/update.js', {updates});
    for (const [id, quantity] of Object.entries(updates)) {
      if (quantity > 0 && variants.has(id) && result.items.filter(l => String(l.variant_id) === id && !Object.keys(l.properties || {}).length).reduce((sum,l) => sum+l.quantity,0) !== quantity) throw new Error(config.error);
    }
    return true;
  });
  window.SoniaPacks = {
    variants, plan, money, calculate,
    handles:id => variants.has(String(id)),
    add:(id, quantity) => run(null, {id, quantity}),
    change:(line, quantity) => run({line:Number(line), quantity:Number(quantity)}),
    normalize:() => run(),
    error:config.error,
    cartUrl:config.root + 'cart'
  };
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.action.includes('/cart/add')) return;
    const data = new FormData(form);
    if (!variants.has(String(data.get('id'))) || form.querySelector('[name^="properties["]') || data.get('selling_plan')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const button = event.submitter || form.querySelector('[type="submit"]');
    if (button?.disabled) return;
    if (button) button.disabled = true;
    const owner = form.closest('product-form');
    owner?.handleErrorMessage?.();
    run(null,{id:String(data.get('id')),quantity:Number(data.get('quantity') || 1)})
      .then(() => window.location.assign(config.root + 'cart'))
      .catch(error => {owner?.handleErrorMessage?.(error.message); if (!owner) window.alert(error.message); if(button) button.disabled=false;});
  }, true);
  const isCart = document.querySelector('cart-items');
  if (isCart) {
    const controls = [...document.querySelectorAll('[name="checkout"],.additional-checkout-buttons')];
    controls.forEach(e => {e.style.pointerEvents='none';e.setAttribute('aria-busy','true');});
    const pending = run().then(changed => {if(changed) window.location.reload(); return changed;});
    pending.catch(error => {
      const output = document.getElementById('cart-errors');
      if (output) output.textContent = error.message;
    }).finally(() => controls.forEach(e => {e.style.pointerEvents='';e.removeAttribute('aria-busy');}));
    document.addEventListener('submit', async event => {
      if (event.submitter?.name !== 'checkout' || event.target.dataset.soniaChecked === 'true') return;
      event.preventDefault();
      event.stopImmediatePropagation();
      try {
        if (await pending || await run()) {window.location.assign(config.root+'cart'); return;}
        event.target.dataset.soniaChecked='true';
        event.target.requestSubmit(event.submitter);
      } catch(error) {const output=document.getElementById('cart-errors');if(output)output.textContent=error.message;}
    },true);
  }
})();
